import { render, staticRenderFns } from "./places2.vue?vue&type=template&id=11a67b8d&scoped=true&"
import script from "./places2.vue?vue&type=script&lang=js&"
export * from "./places2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a67b8d",
  null
  
)

export default component.exports